export function percentile(values: number[], p: number): number {
	if (values.length === 0) {
		return 0;
	}
	if (p <= 0) {
		return Math.min(...values);
	}
	if (p >= 100) {
		return Math.max(...values);
	}
	const sorted = [...values].sort((a, b) => a - b);
	const rank = (p / 100) * (sorted.length - 1);
	const lowerIdx = Math.floor(rank);
	const upperIdx = Math.min(lowerIdx + 1, sorted.length - 1);
	const fraction = rank - lowerIdx;
	return sorted[lowerIdx] + (sorted[upperIdx] - sorted[lowerIdx]) * fraction;
}

// Inverse of `percentile`: given a sorted-ascending sample, returns the percentile (0–100)
// of `target` via linear interpolation between sample positions. Used by the census modal
// to show "≈ p N" for a custom-entered census value.
export function percentileRank(sortedAsc: number[], target: number): number {
	const n = sortedAsc.length;
	if (n === 0) {
		return 0;
	}
	if (target <= sortedAsc[0]) {
		return 0;
	}
	if (target >= sortedAsc[n - 1]) {
		return 100;
	}
	let lower = 0;
	let upper = n - 1;
	while (lower + 1 < upper) {
		const mid = (lower + upper) >> 1;
		if (sortedAsc[mid] <= target) {
			lower = mid;
		} else {
			upper = mid;
		}
	}
	const span = sortedAsc[upper] - sortedAsc[lower];
	const fraction = span === 0 ? 0 : (target - sortedAsc[lower]) / span;
	const rank = lower + fraction;
	return Math.round((rank / (n - 1)) * 100);
}
